/*
 * Copyright (C) 2019 DV Bern AG, Switzerland
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <https://www.gnu.org/licenses/>.
 */

import {Component, inject, ChangeDetectionStrategy} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {TranslateService} from '@ngx-translate/core';

@Component({
    selector: 'dv-ng-select-tragerschaft-email-dialog',
    templateUrl: './dv-ng-select-traegerschaft-email-dialog.template.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DvNgSelectTraegerschaftEmailDialogComponent {
    private readonly dialogRef =
        inject<MatDialogRef<DvNgSelectTraegerschaftEmailDialogComponent>>(
            MatDialogRef
        );
    private readonly translate = inject(TranslateService);
    private readonly data = inject(MAT_DIALOG_DATA);

    public adminMails: string[];
    public selectedMail: string;

    public constructor() {
        const data = this.data;

        this.adminMails = data;
    }

    public save(): void {
        this.dialogRef.close({
            selectedEmail: this.selectedMail
        });
    }

    public close(): void {
        this.dialogRef.close();
    }
}
